import { cx } from './cx';

export type LobbyGender = 'male' | 'female' | 'unspecified';

export interface GenderToggleProps {
  value: LobbyGender;
  onChange: (value: 'male' | 'female') => void;
}

/**
 * Переключатель Ж/М в рамке акцентом (design-spec.md, 02 · Настройка партии).
 * Выбрать можно только Ж или М — третьей кнопки в макете нет.
 *
 * Но до первого касания не подсвечено ничего, и в заявку уезжает
 * `unspecified`. Пол нужен карточкам с адресацией по полу: подставив всем
 * значение по умолчанию, мы отправили бы выдуманные данные, и «человек
 * напротив противоположного пола» указал бы не на того за настоящим столом.
 */
export function GenderToggle({ value, onChange }: GenderToggleProps) {
  return (
    <div className="flex h-full border-2 border-acc">
      <Option label="Ж" active={value === 'female'} onSelect={() => onChange('female')} />
      <Option label="М" active={value === 'male'} onSelect={() => onChange('male')} />
    </div>
  );
}

function Option({
  label,
  active,
  onSelect,
}: {
  label: string;
  active: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={active}
      className={cx(
        'flex h-full min-w-tap appearance-none items-center justify-center rounded-none text-meta font-semibold',
        active ? 'bg-acc text-ground' : 'text-mute',
      )}
    >
      {label}
    </button>
  );
}
